import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { feSidebarOpen } from 'actions/ui.actions';
import NO_IMAGE from 'assets/images/slide-out/user-avatar.svg';
import Button from 'components/form/Button.component';
import TruncatedText from 'components/generic/TruncatedText.component';
import SP from 'constants/ui/sidePanel.const';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { selectCurrentSalonStylists } from 'selectors/currentSalon.selectors';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';

import CN from './ButtonMobileStaff.module.scss';

const ButtonMobileStaff = ({ feSidebarOpen, stylists, selectedStylistId }) => {
  const salonId = useCurrentSalonId();

  const openMobileStaffPanel = useCallback(() => {
    feSidebarOpen({ panel: SP.staffList, salonId });
  }, [feSidebarOpen, salonId]);

  const selectedStylist = stylists.find((s) => s.id === selectedStylistId);

  return (
    <Button tag="ButtonMobileStaff" variant="chameleon" width="auto" noMargin onClick={openMobileStaffPanel}>
      {selectedStylist ? (
        <div data-bem="ButtonMobileStaff__button" className={CN.stylistButton}>
          <div className={CN.profileButtonImgContainer}>
            <img
              data-bem="ButtonMobileStaff__img"
              src={selectedStylist?.profile_image || NO_IMAGE}
              alt={selectedStylist?.user_name || 'Stylist'}
              className={cn({
                [CN.stylistsImage]: true,
                [CN.empty]: !selectedStylist?.profile_image,
              })}
            />
          </div>

          <TruncatedText max={9} suffix="..." value={selectedStylist.user_name} />
        </div>
      ) : (
        <div className={CN.buttonInnerSpace}>ALL STAFF</div>
      )}
    </Button>
  );
};

const ButtonMobileStaffHoc = connect(
  (state) => ({
    stylists: selectCurrentSalonStylists(state),
    selectedStylistId: state?.scheduler?.stylistId,
  }),
  mapActionsToDispatchToProps({
    feSidebarOpen,
  }),
)(ButtonMobileStaff);

export default ButtonMobileStaffHoc;
